import { Converter } from '../types/converter';

export const dataStorageConverter: Converter = {
  id: 'dataStorage',
  name: 'Data Storage Converter',
  icon: 'HardDrive',
  categories: ['common', 'digital'],
  units: [
    // Basic units
    { name: 'Bit', symbol: 'b', factor: 0.125e-8 },
    { name: 'Nibble', symbol: 'nibble', factor: 0.5e-8 },
    { name: 'Byte', symbol: 'B', factor: 1e-8 },
    { name: 'Character', symbol: 'char', factor: 1e-8 },      // Assuming 8-bit character
    { name: 'Word', symbol: 'word', factor: 2e-8 },           // 16 bits
    { name: 'MAPM-word', symbol: 'MAPM', factor: 4e-8 },      // 32 bits
    { name: 'Quadruple-word', symbol: 'qword', factor: 8e-8 }, // 64 bits
    { name: 'Block', symbol: 'block', factor: 512e-8 },       // Traditional disk block
    
    // Binary prefixes (IEC)
    { name: 'Kilobit', symbol: 'kb', factor: 128e-8 },        // 1024 bits
    { name: 'Kilobyte', symbol: 'kB', factor: 1024e-8 },      // 1024 bytes
    { name: 'Kilobyte (10^3 bytes)', symbol: 'kB₁₀', factor: 1000e-8 },
    { name: 'Megabit', symbol: 'Mb', factor: 131072e-8 },     // 1024 kb
    { name: 'Megabyte', symbol: 'MB', factor: 1048576e-8 },   // 1024 kB
    { name: 'Megabyte (10^6 bytes)', symbol: 'MB₁₀', factor: 1000000e-8 },
    { name: 'Gigabit', symbol: 'Gb', factor: 134217728e-8 },  // 1024 Mb
    { name: 'Gigabyte', symbol: 'GB', factor: 1073741824e-8 }, // 1024 MB
    { name: 'Gigabyte (10^9 bytes)', symbol: 'GB₁₀', factor: 1000000000e-8 },
    { name: 'Terabit', symbol: 'Tb', factor: 137438953472e-8 }, // 1024 Gb
    { name: 'Terabyte', symbol: 'TB', factor: 1099511627776e-8 }, // 1024 GB
    { name: 'Terabyte (10^12 bytes)', symbol: 'TB₁₀', factor: 1000000000000e-8 },
    { name: 'Petabit', symbol: 'Pb', factor: 140737488355328e-8 }, // 1024 Tb
    { name: 'Petabyte', symbol: 'PB', factor: 1125899906842624e-8 }, // 1024 TB
    { name: 'Petabyte (10^15 bytes)', symbol: 'PB₁₀', factor: 1000000000000000e-8 },
    { name: 'Exabit', symbol: 'Eb', factor: 144115188075855872e-8 }, // 1024 Pb
    { name: 'Exabyte', symbol: 'EB', factor: 1152921504606846976e-8 }, // 1024 PB
    { name: 'Exabyte (10^18 bytes)', symbol: 'EB₁₀', factor: 1000000000000000000e-8 },
    
    // Storage media capacities
    { name: 'Floppy disk (3.5", DD)', symbol: 'FD-DD', factor: 720000e-8 },    // 720 KB
    { name: 'Floppy disk (3.5", HD)', symbol: 'FD-HD', factor: 1440000e-8 },   // 1.44 MB
    { name: 'Floppy disk (3.5", ED)', symbol: 'FD-ED', factor: 2880000e-8 },   // 2.88 MB
    { name: 'Floppy disk (5.25", DD)', symbol: 'FD5-DD', factor: 360000e-8 },  // 360 KB
    { name: 'Floppy disk (5.25", HD)', symbol: 'FD5-HD', factor: 1200000e-8 }, // 1.2 MB
    { name: 'Zip 100', symbol: 'ZIP-100', factor: 100000000e-8 },              // 100 MB
    { name: 'Zip 250', symbol: 'ZIP-250', factor: 250000000e-8 },              // 250 MB
    { name: 'Jaz 1GB', symbol: 'JAZ-1', factor: 1000000000e-8 },               // 1 GB
    { name: 'Jaz 2GB', symbol: 'JAZ-2', factor: 2000000000e-8 },               // 2 GB
    { name: 'CD (74 minute)', symbol: 'CD-74', factor: 650000000e-8 },         // 650 MB
    { name: 'CD (80 minute)', symbol: 'CD-80', factor: 700000000e-8 },         // 700 MB
    { name: 'DVD (1 layer, 1 side)', symbol: 'DVD-1', factor: 4700000000e-8 }, // 4.7 GB
    { name: 'DVD (2 layer, 1 side)', symbol: 'DVD-2', factor: 8500000000e-8 }, // 8.5 GB
    { name: 'DVD (1 layer, 2 side)', symbol: 'DVD-1-2', factor: 9400000000e-8 }, // 9.4 GB
    { name: 'DVD (2 layer, 2 side)', symbol: 'DVD-2-2', factor: 17000000000e-8 }  // 17 GB
  ]
};
